import { render, staticRenderFns } from "./Disconnection.vue?vue&type=template&id=6f240c22&"
import script from "./Disconnection.vue?vue&type=script&lang=js&"
export * from "./Disconnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports